import { transformFetchedPlanData } from 'helpers'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import getPlans from 'services/plans'
import actions from './actions'

export function* GET_PLANS() {
  const fetchedPlanDataOrBool = yield call(getPlans)
  if (typeof fetchedPlanDataOrBool !== 'boolean') {
    const transformedPlanData = transformFetchedPlanData(fetchedPlanDataOrBool)
    if (transformedPlanData !== null) {
      yield put({
        type: 'plans/SET_STATE',
        payload: { ...transformedPlanData },
      })
    }
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_PLANS, GET_PLANS)])
}
